module.exports = __webpack_public_path__ + "img/wxQRCode.45061060.png";